const supportedGiveTransactionResults = {
  error: 1,
  success: 1,
};

export type GiveTransactionResult = keyof typeof supportedGiveTransactionResults;

export const isGiveTransactionResult = (value?: unknown): value is GiveTransactionResult =>
  typeof value === 'string' ? value in supportedGiveTransactionResults : false;

export type TransactionResultParams = {
  onModalClose: () => void;
  transactionResult?: GiveTransactionResult;
};
